import React, { useState } from "react";
import styled from "styled-components";

export const CopyButton = ({ value, copyText, copiedText }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <Button onClick={handleCopy} isCopied={isCopied}>
      {isCopied ? copiedText : copyText}
    </Button>
  );
};

const Button = styled.button`
  background-color: ${({ isCopied }) => (isCopied ? "#10B981" : "#EEF2FF")};
  color: ${({ isCopied }) => (isCopied ? "white" : "#4F46E5")};
  border: none;
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${({ isCopied }) => (isCopied ? "#10B981" : "#4F46E5")};
    color: white;
  }
`;
